// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__ECbt7","index":"styles_index__30t_K"};